<template>
    <div class="card border-0 h-800">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" :data-url='selectedUrl ? `companiesResources/${inputs.id}` : `companiesResources`' class="mb-0" :class="{ 'loading-opacity': preloader }">
                <ShortName v-model="inputs.Second_Title" />
                <SupplierDescription v-model="inputs.description" />
                <BillAddress v-model="inputs.BillAddress" />
                <SupplierCountry v-model="inputs.country" />    
                <SupplierState v-model="inputs.state" :country_id="inputs.country.id" />
                <SupplierCity v-model="inputs.city" :state_id="inputs.state.id" />
                <PostalCode v-model="inputs.PostalZipCode" />
                <SupplierPhone v-model="inputs.phone" />
                <SupplierFax v-model="inputs.fax" />
                <SupplierEmail v-model="inputs.Email" />
                <SupplierFda v-model="inputs.fda" />
                <SupplierStatus v-model="inputs.status" :list="stateList" />
                <div class="mt-5 action-buttons">
                    <button type="button" class="btn btn-primary mr-2" @click="continueBy">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin.js";
import { axiosGet } from "../../../../Helpers/AxiosHelper.js";
import * as actions from "../../../../Config/ApiUrl.js";
import {validateInputs} from "../../../../../utils";
import ShortName from '../components/ShortName.vue';
import SupplierDescription from '../components/SupplierDescription.vue';
import BillAddress from '../components/BillAddress.vue';
import SupplierCountry from '../components/SupplierCountry.vue';
import SupplierState from '../components/SupplierState.vue';
import SupplierCity from '../components/SupplierCity.vue';
import PostalCode from '../components/PostalCode.vue';
import SupplierPhone from '../components/SupplierPhone.vue';
import SupplierFax from '../components/SupplierFax.vue';
import SupplierEmail from '../components/SupplierEmail.vue';
import SupplierFda from '../components/SupplierFda.vue';
import SupplierStatus from '../components/SupplierStatus.vue';

export default {
    name: "add_supplier_form",
    mixins: [FormMixin, ModalMixin],
    props: {
        selectedUrl: {
            type: String,
            default: 'edit'
        }
    },
    components :{
        ShortName, SupplierDescription, BillAddress, SupplierCountry, SupplierState, SupplierCity, PostalCode, SupplierPhone, SupplierFax, SupplierEmail, SupplierFda, SupplierStatus
    },
    data() {
        return {
            preloader: false,
            url: this.$route.query.selectedUrl,
            inputs: {
                Second_Title: '',
                description: '',
                BillAddress: '',
                fax: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                PostalZipCode: '',
                phone: '',
                ext: '',
                Email: '',
                status: '',
                company_type_id: 2,
                id: null,
                fda : '',
            },
            stateList: [
                { id: 'active', value: "Active" },
                { id: 'inactive', value: "Inactive" }
            ],
        };
    },
    methods: {
        validations() {
            const validations = {
                Second_Title: { required: true,  message: 'long name must be between 3 and 100 characters' },
                BillAddress: { required: true,  message: 'the BillAddress is required' },
                'country.id': { required: true,  message: 'the country is required' },
                'state.id': { required: true,  message: 'the state is required' },
                'city.id': { required: true,  message: 'the city is required' },
                PostalZipCode : { required: true, message: 'the postal Zip Code is required' },
            };
            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }
            return true
        },

        continueBy() {
            if (!this.validations()) {
                return;
            }
            const DataCompanies = JSON.parse(localStorage.getItem('DataCompaniesEdit')) || {};
            this.save(DataCompanies)
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.data.message); // Muestra el mensaje de éxito
            localStorage.removeItem('DataCompaniesEdit');
            localStorage.setItem('DataCompaniesEdit', JSON.stringify(response.data.data.Company));
            let res = JSON.parse(response.data.data.Company);
            this.updateAddressInLocalStorage(res.data.data.Company)
        },

        updateAddressInLocalStorage(updatedAddress) {
            let storedAddresses = JSON.parse(localStorage.getItem('DataCompaniesEdit')) || [];
            const existingIndex = storedAddresses.findIndex(address => address.id === updatedAddress.id);
            if (existingIndex !== -1) {
                storedAddresses[existingIndex] = updatedAddress;
            } else {
                storedAddresses.push(updatedAddress);
            }
            localStorage.setItem('DataCompaniesEdit', JSON.stringify(storedAddresses));
            let res = JSON.parse(localStorage.getItem('DataCompaniesEdit'));
            this.inputs.Second_Title = res.Second_Title || '';
            this.inputs.PostalZipCode = res.PostalZipCode || '';
            this.inputs.Email = res.Email || '';
            this.inputs.description = res.description || '';
            this.inputs.BillAddress = res.BillAddress || '';
            this.inputs.phone = res.phone || '';
            this.inputs.fax = res.fax || '';
            this.inputs.status = res.status || '';
            this.inputs.id = res.id || '';
            this.inputs.country = res.country || {};
            this.inputs.state = res.state || {};
            this.inputs.city = res.city || {};
            this.inputs.fda = res.fda ?? '';
        }
    },

    watch: {
        inputs: {
            deep: true, 
            handler(newVal) {
                localStorage.setItem('DataCompaniesEdit', JSON.stringify(newVal));
            }
        }
    },

    created() {
        if (localStorage.getItem('DataCompaniesEdit')) {
            localStorage.removeItem('DataCompanies');
        }
        if (this.url) {
            const DataCompaniesEdit = localStorage.getItem('DataCompaniesEdit');
            let res = JSON.parse(DataCompaniesEdit);
            this.inputs.Second_Title = res.Second_Title || '';
            this.inputs.PostalZipCode = res.PostalZipCode || '';
            this.inputs.Email = res.Email || '';
            this.inputs.description = res.description || '';
            this.inputs.BillAddress = res.BillAddress || '';
            this.inputs.fax = res.fax || '';
            this.inputs.status = res.status || '';
            this.inputs.id = res.id || '';
            this.inputs.phone = res.phone || '';
            this.inputs.country = res.country || {};
            this.inputs.state = res.state || {};
            this.inputs.city = res.city || {};
            this.inputs.fda = res.fda ?? '';
        }
    }
}
</script>
